module.exports = __webpack_public_path__ + "img/annulus.0887ad7e.png";